<!--入库单查询-->
<template>
	<div class="content">
        <h3>入库单查询</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="80px">
				<el-form-item label="时间类型">
					<el-select v-model="form.timestate" placeholder="请选择" >
						<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="起始日期">
					<el-date-picker
						v-model="form.starttime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="终止日期">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item label="入库单号">
					<el-input v-model="form.odd" placeholder="请输入单号" clearble></el-input>
				</el-form-item>
				<el-form-item label="产品大类">
					<el-input v-model="form.product" placeholder="请选择" :value="form.productnum" @focus="productfocus"></el-input>
				</el-form-item>
                <el-form-item label="产品">
					<el-input v-model="form.product" placeholder="请选择" :value="form.productnum" @focus="productfocus"></el-input>					
				</el-form-item>

                <el-form-item label="入库库房">
					<el-select v-model="form.outstore" @change="selChange" @focus="getStore" placeholder="请选择" >
						<el-option
						v-for="item in warehouse"
						:key="item.StoreCode"
						:label="item.StoreName"
						:value="item.StoreCode">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="入库类型">
					<el-select v-model="form.outstate" placeholder="请选择" >
						<el-option
						v-for="item in outstock"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="数码">
					<el-input v-model="form.num" placeholder="请输入数值" clearble></el-input>
				</el-form-item>

                 <el-form-item style="width:100%;margin:0 80px;">
					<el-checkbox v-model="form.checked1">只查看单据计划量与处理成功数量不一致的单据</el-checkbox>
				</el-form-item>
                 <el-form-item style="width:100%;margin:0 80px;">
					<el-checkbox v-model="form.checked2">显示已删除、已覆盖的单据</el-checkbox>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary" @click="selectQry">查 询</el-button>
                <el-button type="warning">重 置</el-button>
			</div>
		</div>
		<el-dialog title="选择产品" :visible.sync="dialogVisible" width="600px">
			<el-table :data="gridData" highlight-current-row
  			@row-click="handleCurrentChange">
				<!--<el-table-column align="center" width="80" property="id" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="num" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="name" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="pr" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="scale" label="包装比例"></el-table-column>-->
				<el-table-column align="center" width="80" property="DataId" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="Productcode" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="Productname" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="Shortname" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="Norms" label="包装比例"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
		<div class="item">
			<el-table :data="tableData" border >
				<el-table-column prop="Order" align="center" label="入库单号"></el-table-column>
				<el-table-column prop="AddTime" align="center" label="创建时间"></el-table-column>
				<el-table-column prop="OutTime" align="center" label="更新时间"></el-table-column>
                <el-table-column prop="ShipperName" align="center" label="发货单位"></el-table-column>
                <el-table-column prop="OutType" align="center" label="入库类型"></el-table-column>
				<el-table-column prop="ReceiverName" align="center" label="收货单位"></el-table-column>
                <el-table-column prop="ReceiverId" align="center" label="收货单位编码"></el-table-column>
                <el-table-column prop="OperUser" align="center" label="操作员"></el-table-column>
                <el-table-column prop="Remark" align="center" label="备注"></el-table-column>
                <el-table-column align="center" label="查看异常" >
					<template slot-scope="scope">
						<el-button type="text" @click="ShowExecptionProduct(scope)">查看</el-button>
					</template>
				</el-table-column>
                <el-table-column align="center" label="详情" >
					<template slot-scope="scope">
						<el-button type="text" @click="ShowProduct(scope)">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentPageChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			dialogVisible: false,
			form: {
				timestate: 1, //时间类型
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //出库单号
				product: '',   //产品名称
				productnum:'', //产品编号
				outstore:'',   //出库库房
				outstate:'',   //出库类型
				num:'',        //数码
				checked1: false,  //单据类型选择
				checked2: false,  //单据类型选择
			},
			//时间类型
			options: [{
				value: 1,
				label: '创建时间'
				}, {
				value: 2,
				label: '更新时间'
			}],
			warehouse: [],
			//入库类型
            outstock: [{
				value: 1,
				label: '销售入库'
			},{
				value: 2,
				label: '调拨入库'
			}],
            

			gridData: [],
			current:null,
			tableData: [],
			pageIndex:1,
			pageNum:0,

			instoreinfo:{
				Order:'',//入库单号
				AddTime:'',//创建时间
				OutType:'',//入库类型
				OutTime:'',//入库时间
				ShipperName:'',//发货单位
				OperUser:'',//操作员
				ReceiverName:'',//收货单位
				Remark:'',//备注
			}
		}
	},
	methods:{
		selChange(val){
			
			
		},
		confirm(){
			this.form.product = this.current.Shortname + this.current.Productname +this.current.Norms;
			this.form.productnum = this.current.Productcode;
			this.dialogVisible = false
		},
		handleCurrentChange(data){
			this.current = data
		},


		productfocus(){
			//	请求产品数据
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params:{
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
					if(res.Code==0){
						this.gridData=res.DataList;
					}else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
			this.dialogVisible = true
		},

		getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
					console.log(res);
					if(res.Code==0){
						this.warehouse=res.DataList;
					}else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}      
			})
		},
		
		handleCurrentPageChange(index){
			this.pageIndex=index;
			this.selectQry()
		},

		selectQry(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			console.log(this.form)
			this.$axios({
				method: 'post',
				url:'/FW/OutListQry.ashx',
				params:{
					action:"InListQry",
					qry: this.form,
					cid:user.QyNum,
					pageIndex:this.pageIndex
				}
			})
			.then(res=>{
				console.log(res)
				if(res.Code==0){
					this.tableData=res.Data.DataList
					this.pageNum=res.Data.Total
				}else{
					this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
		},
		//展示详情
		ShowProduct(scope){
			if(scope==null){
				this.$message({
            			showClose: true,
            			message:"入库单信息为空。",
            			type: 'warning'
					});
			}
			console.log(scope)
			this.instoreinfo.Order=scope.row.Order;
			this.instoreinfo.AddTime=scope.row.AddTime;
			this.instoreinfo.OutType=scope.row.OutType;
			this.instoreinfo.OutTime=scope.row.OutTime;
			this.instoreinfo.ShipperName=scope.row.ShipperName;
			this.instoreinfo.OperUser=scope.row.OperUser;
			this.instoreinfo.ReceiverName=scope.row.ReceiverName;
			this.instoreinfo.Remark=scope.row.Remark;
			this.$router.push({name:"inListDetails",query: { instoreinfo: this.instoreinfo }})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
.el-checkbox{
    line-height: 19px;
}
</style>


// WEBPACK FOOTER //
// src/pages/inListQry.vue